import moment from 'moment'
import { formatDateTime } from '@cbgms/base/utils/datetime'

interface Props {
  content: moment.MomentInput
}

export function Date({ content }: Props) {
  return <>{formatDateTime(content)}</>
}
